
export enum GlobalTypes {
    CLEAR = '@global/CLEAR',
    LOGOUT = '@global/LOGOUT'
}
